import * as yup from "yup";

export interface TaskDrawerFormValues {
  name: string;
  surveyid: string; // stored as string for FTPSelect; convert to number on submit
  count: string; // stored as string for FTPInput; convert to number on submit
  node: any;
  user: any | null;
}

const requiredString = yup.string().trim().required("This field is required");

export const taskDrawerSchema = yup.object({
  name: requiredString.max(200, "Name is too long"),
  surveyid: requiredString,
  count: yup
    .string()
    .required("Please enter a valid number of interviews")
    .test("is-positive-int", "Please enter a valid number of interviews", (value) => {
      const n = parseInt(String(value || ""), 10);
      return Number.isFinite(n) && n > 0;
    }),
  // Booth is optional in edit mode
  node: yup.mixed().nullable(),
  user: yup.mixed().nullable(),
});

